/**
 * Reliable clipboard copy with fallback for non-HTTPS environments.
 * Uses navigator.clipboard.writeText when available, falls back to execCommand.
 */
export async function copyToClipboard(text) {
  if (!text) return false;

  // Try modern API first (requires HTTPS / secure context)
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      // Fall through to fallback
    }
  }

  // Fallback: hidden textarea + execCommand
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '-9999px';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (err) {
    console.error('Clipboard copy failed:', err);
    return false;
  }
}
